import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-pdn-range',
  templateUrl: './pdn-range.component.html',
  styleUrls: [],
  standalone: false
})
export class PdnRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
